import { jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import { Widget } from './Widget';
export function DockedWidgetPlaceholder(props) {
    return (_jsx(Components.BtnGroup, { children: props.widgets.map(([widget, placement], index) => (_jsx(Widget, { id: widget.id, type: Common.WidgetSize.MinButton, placementManager: props.placementManager, placeholderType: Common.WidgetPlaceholderType.Docked, placement: placement, allowFallback: true }, index))) }));
}
